import { CardWrapper, Tabs } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { ProductGroupedDownloadItemInterface } from "../../interfaces/apiV2/product/ProductDownloadsInterface";
import { useProductDownloads } from "../../hooks/productDetail/useProductDownloads";
import { ProductDownloadTabId } from "../../utils/productDetail/productDownloadsConstants";
import { ProductDownloadsGrid } from "./components/downloads/ProductDownloadsGrid";

interface Props {
    marketingDownloads: Record<string, ProductGroupedDownloadItemInterface[]>;
    technicalDownloads: Record<string, ProductGroupedDownloadItemInterface[]>;
    marketingDownloadsCount: number;
    technicalDownloadsCount: number;
}

export const ProductDownloads = ({
    marketingDownloads,
    technicalDownloads,
    marketingDownloadsCount,
    technicalDownloadsCount,
}: Props): JSX.Element | null => {
    const {
        hasContent,
        showTabs,
        tabs,
        cardTitle,
        downloadsLabel,
        activeTabId,
        setActiveTabId,
        downloadEntries,
    } = useProductDownloads({
        marketingDownloads,
        technicalDownloads,
        marketingDownloadsCount,
        technicalDownloadsCount,
    });

    if (!hasContent) {
        return null;
    }

    return (
        <CardWrapper
            title={showTabs ? cardTitle : downloadsLabel}
            titleAddon={
                showTabs ? (
                    <Tabs
                        tabs={tabs}
                        activeId={activeTabId}
                        onChange={(id: string) =>
                            setActiveTabId(id as ProductDownloadTabId)
                        }
                    />
                ) : undefined
            }
            showHeaderDivider
        >
            <ProductDownloadsGrid entries={downloadEntries} />
        </CardWrapper>
    );
};
